import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class GooglePlacesService {
  private searchBox: google.maps.places.Autocomplete;
  private readonly googlePlace$$: BehaviorSubject<google.maps.places.PlaceResult> = new BehaviorSubject(null);
  public googlePlace$: Observable<google.maps.places.PlaceResult> = this.googlePlace$$.asObservable();

  constructor(private readonly ngZone: NgZone) {}

  public init(htmlElement: HTMLInputElement, defaultBounds: google.maps.LatLngBounds = null): void {
    this.searchBox = new google.maps.places.Autocomplete(htmlElement, {
      bounds: defaultBounds,
      types: ['establishment'],
    });
    this.initSearchBox();
  }

  private initSearchBox(): void {
    this.searchBox.setFields([
      'address_component',
      'adr_address',
      'business_status',
      'formatted_address',
      'geometry.location',
      'icon',
      'name',
      'place_id',
      'type',
      'url',
      'formatted_phone_number',
      'opening_hours',
      'website',
    ]);
    this.searchBox.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = this.searchBox.getPlace();
        this.setGooglePlaces(place);
      });
    });
  }

  public setGooglePlaces(places: google.maps.places.PlaceResult): void {
    this.googlePlace$$.next(places);
  }

  destroy(): void {
    this.googlePlace$$.complete();
  }
}
